/**
 * stripe.js — Singleton Stripe partagé (front).
 *
 * Charge le SDK Stripe UNE SEULE FOIS pour toute l'application via `loadStripe`
 * (recommandation officielle Stripe : un seul `stripePromise` au niveau module,
 * jamais re-instancié par composant). Tous les composants qui montent
 * `<Elements stripe={stripePromise}>` importent CE singleton — jamais de
 * `loadStripe(...)` inline (anti-duplication §74, DRY §9).
 *
 * Clé publishable : process.env.REACT_APP_STRIPE_PUBLIC_KEY.
 *
 * Consommateurs : stripeModal.jsx, CounterAcceptModal.jsx, CartCheckoutModal.jsx.
 */
import { loadStripe } from '@stripe/stripe-js';

export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
